// Toast wording for queuing AI analysis of a Review selection (products without an image are skipped).
const plural = (n) => `${n} ${n === 1 ? 'product' : 'products'}`;

export function queuedText(ids, r) {
  const skipped = (r && r.skipped_no_image) || 0;
  return plural(Math.max(0, ids.length - skipped));
}

export function skippedText(r) {
  const skipped = (r && r.skipped_no_image) || 0;
  return skipped > 0 ? ` · ${plural(skipped)} without an image skipped` : '';
}
